export default __webpack_public_path__ + "static/media/reporte.9b002c50.svg";